import type { HeaderGroup } from "./types";
import type { Column } from "@/lib/table-columns";

export const buildHeaderGroups = (columns: Column[]): HeaderGroup[] => {
  return columns.reduce(
    (acc, col) => {
      const lastGroup = acc[acc.length - 1];

      if (col.group) {
        if (lastGroup && lastGroup.isGroup && lastGroup.name === col.group) {
          lastGroup.colSpan += 1;
        } else {
          acc.push({ name: col.group, colSpan: 1, isGroup: true });
        }
      } else {
        acc.push({
          name: col.key,
          colSpan: 1,
          isGroup: false,
          label: col.label,
        });
      }
      return acc;
    },
    [] as HeaderGroup[],
  );
};
